var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal && _vm.slides.length > 0
    ? _c(
        "Modal",
        {
          attrs: {
            id: "firstrunwizard",
            "has-previous": _vm.hasPrevious,
            "has-next": _vm.hasNext,
            size: _vm.isMobile ? "full" : "normal",
            name: "modal"
          },
          on: { previous: _vm.previous, next: _vm.next, close: _vm.close }
        },
        [
          _vm.currentSlide !== 0 || !_vm.withIntro || !_vm.hasVideo
            ? _c("div", { staticClass: "modal-header" }, [
                _c("div", { staticClass: "firstrunwizard-header" }, [
                  _c("div", { staticClass: "logo" }, [
                    _c("p", { staticClass: "hidden-visually" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.oc_defaults.name) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h2", {
                    domProps: { innerHTML: _vm._s(_vm.oc_defaults.slogan) }
                  }),
                  _vm._v(" "),
                  _c("p")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.slideList.length > 0
                ? _vm._t("body", [
                    _c(
                      "transition",
                      { attrs: { name: _vm.fadeDirection, mode: "out-in" } },
                      [
                        _vm.slideList[_vm.currentSlide].type === "inline"
                          ? _c("div", {
                              key: _vm.currentSlide,
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.slideList[_vm.currentSlide].content
                                )
                              }
                            })
                          : _c(_vm.slideList[_vm.currentSlide], {
                              tag: "div",
                              on: {
                                finished: function($event) {
                                  _vm.currentSlide++
                                }
                              }
                            })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _vm.isLast
              ? _c(
                  "button",
                  {
                    staticClass: "primary modal-default-button",
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(
                          _vm.t("firstrunwizard", "Start using Nextcloud")
                        ) +
                        "\n\t\t"
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }